import React, { memo } from 'react'
import styles from './CommonIncrementInput.module.scss'
import { UseFormRegisterReturn } from 'react-hook-form'


type Props = {
    value: number
    unit?: string
    inputProps?: UseFormRegisterReturn<any>;
    min?: number
    max?: number
    incrementInvisible?: boolean
    placeholder?: string
    onChange: (value: number) => void
    onChangeHelper?: (value: number) => void
}

const CommonIncrementInput: React.FC<Props> = memo((props: Props) => {
    const { value, unit, onChange, inputProps, min, max } = props

    function increment() {
        onChange(parseInt(value.toString()) + 1)
    }

    function decrement() {
        onChange(parseInt(value.toString()) - 1)
    }

    return (
        <div className={styles.container}>
            <div className={styles.inputContainer}>
                <input 
                className={styles.input} 
                type='number'
                onChange={(x) => props.onChangeHelper != null ? props.onChangeHelper(parseInt(x.target.value)) : null}
                {...inputProps}
                min={min}
                max={max}
                placeholder={props.placeholder}
                
                />
                {
                    unit && <div className={styles.unit}>{unit}</div>
                }
            </div>

            { props.incrementInvisible ??
                <div className={styles.incrementContainer}>
                    <button className={styles.button + ' ' + styles.leftButton} onClick={decrement}>-</button>
                    <button className={styles.button} onClick={increment}>+</button>
                </div>
            }
        </div>
    )
})

export default CommonIncrementInput